<template>

<div>

  <div>

    <h1>Create new tour</h1>

    <Errors/>

    <div class="box">

      <form class="form" v-on:submit.prevent="createTour">

        <TourFields 
          :countries="countries" 
          :bonding_types="bondingTypes" 
        />

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Creating tour...</span></button>
          </div>
          <div v-else>
            <button type="submit" class="button"><span>Create tour</span></button>
          </div>
        </div>

      </form>

    </div>

  </div>
</div>


</template>

<script>
import TourFields from '@/components/TourFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'TourEdit',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      tour: {},
      countries: null,
      bonding_types: null,
      errors: null,
      newInstance: {
        currency: 'GBP',
        indirect_flights: 1
      }
    }
  },
  components: {
    TourFields,
    Errors
  },
  created () {
    this.getTourData()
  },
  methods: {
    createTour () {
      this.$store.dispatch('setLoadStatus')
      let formData = new FormData();

      formData.append('tour', JSON.stringify(this.tour));
      formData.append('information_doc_file', this.tour.tour_info_doc);
      formData.append('name', this.tour.name);
      formData.append('tour_type', this.tour.tour_type);
      formData.append('reference', this.tour.reference);
      formData.append('deposit_price', this.tour.deposit_price);
      formData.append('destination', this.tour.destination);
      formData.append('bonding_type_id', this.tour.bonding_type_id);
      formData.append('minimum_age', this.tour.minimum_age);
      formData.append('release_days_before', this.tour.release_days_before);
      formData.append('tour_places', this.tour.tour_places);

      fetch(this.$api + 'tours/', {
        method: 'POST',
        body: formData,
        headers:{
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$router.push({ name: 'tour-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    getTourData() {
      fetch(this.$api + 'tours/tour-data', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
        .then(response => {
        this.bondingTypes = response.data.bonding_types
        this.countries = response.data.countries
      })
    },
  }
}
</script>
